'use client'
import { getScreenOrientation } from '@/ug-core/utils/deviceUtils'
import { avatars } from '../playground-avatar/config/avatars'
import Demo from './Demo'

export default function StoryTellPage() {
  // on prd and dev it's the same component id
  const COMPONENT = 'comp-ug.story_teller.story_telling_-792a'
  const PERSONA = '7dd1c64772042af0fd09d001a70938db'
  const AVATAR = avatars.pink_robot
  const IMAGE_FRAME = 'fullscreen'

  return (
    <Demo
      componentId={COMPONENT}
      personaId={PERSONA}
      avatarAsset={AVATAR}
      imageFrame={IMAGE_FRAME}
      contextValues={{
        is_horizontal: getScreenOrientation() === 'horizontal',
      }}
    />
  )
}
